/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022-2023 (original work) Open Assessment Technologies SA ;
 */
import { itemSessionStates } from '../session/sessionStates.js';

/**
 * Find out if late submission is allowed for the specified timer
 * @param {Object} testContext
 * @param {Object} timer
 * @returns {Boolean}
 */
export function getAllowLateSubmission(testContext, timer) {
    if (testContext.timeConstraints && typeof testContext.timeConstraints === 'object') {
        const array = Array.isArray(testContext.timeConstraints)
            ? testContext.timeConstraints
            : Object.values(testContext.timeConstraints);
        const timeConstraint = array.find(constr => {
            if (constr.qtiClassName === 'assessmentTest' && timer.level === 'test') {
                return true;
            }
            if (
                (constr.qtiClassName === 'testPart' && timer.level === 'testPart') ||
                (constr.qtiClassName === 'assessmentSection' && timer.level === 'section') ||
                (constr.qtiClassName === 'assessmentItemRef' && timer.level === 'item')
            ) {
                return constr.source === timer.id;
            }
            return false;
        });
        if (timeConstraint) {
            return timeConstraint.allowLateSubmission;
        }
    }
    return false;
}

/**
 * If item is in a 'modalFeedback' state
 * @param {*} testContext
 * @returns {Boolean}
 */
export function isItemModalFeedbackState(testContext) {
    return testContext.itemSessionState === itemSessionStates.modalFeedback;
}
